export default "<div class=\"pf-job-card pf-job-card--standard\"\n     layout=\"column\">\n</div>\n";